const podium = {
  1: { backgroundColor: '#FFD700', color: '#241A00' }, // gold
  2: { backgroundColor: '#C0C0C0', color: '#1A1A1A' }, // silver
  3: { backgroundColor: '#CD7F32', color: '#241100' }, // bronze
};

export default function RankBadge({ position }) {
  const medal = podium[position];

  if (medal) {
    return (
      <span
        className="w-8 h-8 flex items-center justify-center rounded-full font-headline font-bold text-sm tabular-nums"
        style={medal}
      >
        {position}
      </span>
    );
  }

  return (
    <span className="w-8 h-8 flex items-center justify-center font-headline font-semibold text-sm tabular-nums text-on-surface-variant">
      {position}
    </span>
  );
}
